import Vue from 'vue';
import VueRouter from 'vue-router';
import VueSilentbox from 'vue-silentbox';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Paginate from 'vuejs-paginate';
import BootstrapVue from 'bootstrap-vue';
import moment from 'moment-timezone';
import VueCurrencyFilter from 'vue-currency-filter';
import Loading from 'vue-loading-overlay';
import vueDrawer from 'vue-drawer-plugin';
import VueCookies from 'vue-cookies';
import { i18n } from './plugins/i18n';
import firebase from 'firebase/app';
import SimpleVueValidation from 'simple-vue-validator';
import VueLazyload from 'vue-lazyload';
import VueHead from 'vue-head';
import VueAnalytics from 'vue-analytics';
import LoadScript from 'vue-plugin-load-script';
import http from '../helper/http';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-loading-overlay/dist/vue-loading.css';
import '../css/style.css?af435'; // REMOVE CACHED change variable
import '../css/arial/style.css';
import '../css/helvetica-neue/style.css';
import 'firebase/auth';
import './bootstrap';
import './input';


window.Vue = Vue;
moment.tz.setDefault('Asia/Jakarta');
moment.suppressDeprecationWarnings = true;
Vue.use(LoadScript);
Vue.use(VueCookies);
Vue.use(vueDrawer);
Vue.use(VueRouter);
Vue.use(VueSilentbox);
Vue.use(VueAxios, axios);
Vue.use(VueHead);
Vue.use(BootstrapVue);
Vue.use(moment);
Vue.use(SimpleVueValidation);
Vue.use(VueLazyload);
Vue.use(Loading, {
  color: '#EE2F26',
  backgroundColor: 'rgba(38, 38, 38, .95)',
  opacity: 0.75,
});
Vue.use(VueCurrencyFilter, {
  symbol: 'Rp.',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: '',
  symbolPosition: 'front',
  symbolSpacing: true,
});

Vue.component('paginate', Paginate);
Vue.component('SimpleVueValidation', SimpleVueValidation);

// Vue.loadScript('./plugins/imagemapresizer.min.js')
const routes = [
  { path: '/home', component: () => import('./views/Home.vue') },
  { path: '/profile', component: () => import('./views/Profile.vue') },
  { path: '/change-password', component: () => import('./views/ChangePassword.vue') },
  { path: '/my-tickets', component: () => import('./views/MyTickets.vue') },
  { path: '/search', name: 'search', component: () => import('./views/Search.vue') },
  { path: '/events', name: 'event', component: () => import('./views/Events.vue') },
  { path: '/movies', name: 'movie', component: () => import('./views/Movies.vue') },
  { path: '/travels', name: 'travel', component: () => import('./views/Travels.vue') },
  { path: '/wahana', name: 'wahana', component: () => import('./views/Wahana.vue') },
  { path: '/event/:slug', component: () => import('./views/DetailEvent.vue') },
  { path: '/event-buy/:slug', component: () => import('./views/OnePageDetailEventV2.vue') },
  // { path: '/event-buy-v2/:slug', component: () => import('./views/OnePageDetailEventV2.vue') },
  { path: '/multi-event/:slug', component: () => import('./views/DetailMultiEvent.vue') },
  { path: '/news', name: 'news', component: () => import('./views/News.vue') },
  { path: '/detail-news/:slug', component: () => import('./views/DetailNews.vue') },
  { path: '/about-us', name: 'about-us', component: () => import('./views/AboutUs.vue') },
  { path: '/customer-support', name: 'customer-support', component: () => import('./views/CustomerSupport.vue') },
  { path: '/tnc', name: 'tnc', component: () => import('./views/Tnc.vue') },
  { path: '/privacy', name: 'privacy', component: () => import('./views/Privacy.vue') },
  { path: '/how-to-buy', name: 'how-to-buy', component: () => import('./views/HowToBuy.vue') },
  { path: '/contact-us', component: () => import('./views/ContactUs.vue') },
  { path: '/faq', name: 'faq', component: () => import('./views/Faq.vue') },
  { path: '/partnership', name: 'partnership', component: () => import('./views/Partnership.vue') },
  { path: '/search-empty', component: () => import('./views/SearchEmpty.vue') },
  { path: '/search-mobile', component: () => import('./views/SearchMobile.vue') },
  { path: '/search-result', component: () => import('./views/SearchResult.vue') },
  { path: '/detail-event', component: () => import('./views/DetailEvent.vue') },
  { path: '/buy/:slug', component: () => import('./views/BuyV2.vue') },
  // { path: '/buy-v2/:slug', component: () => import('./views/BuyV2.vue') },
  { path: '/lmbuy/:slug', component: () => import('./views/BuyEconcert.vue') },
  { path: '/confirm-buy/:slug', component: () => import('./views/ConfirmBuy.vue') },
  { path: '/confirmation', component: () => import('./views/ConfirmBuy.vue') },
  { path: '/pjf2023', component: () => import('./views/Pjf2023.vue') },
  { path: '/refunds/:slug', component: () => import('./views/NewRefund.vue') },
  { path: '/refund', component: () => import('./views/Refund.vue') },
  { path: '/email-verify-v2', component: () => import('./views/CustomVerified.vue') },

  { path: '/transaction-info/:uuid', component: () => import('./views/BankTransfer.vue') },

  // { path: '/upgrade', component: () => import('./views/Upgrade.vue') },
  { path: '/add-on', component: () => import('./views/AddOn.vue') },
  // { path: '/buy/:slug/:cat_slug', component: () => import('./views/Buy.vue') },
  { path: '/buy-confirmed', component: () => import('./views/BuyConfirmed.vue') },
  { path: '/not-found', component: () => import('./views/NotFound.vue') },
  { path: '/stepper', component: () => import('./views/Stepper.vue') },
  { path: '*', redirect: '/home' },
];

const firebaseConfig = {
  apiKey: "AIzaSyBYSwrRJYee4IsflpzWpRx5r59PNYeJtjE",
  authDomain: "tiketapasaja-livechat.firebaseapp.com",
  databaseURL: "https://tiketapasaja-livechat.firebaseio.com",
  projectId: "tiketapasaja-livechat",
  storageBucket: "tiketapasaja-livechat.appspot.com",
  messagingSenderId: "834529958787",
  appId: "1:834529958787:web:b925da2ba2330324ee34b6",
  measurementId: "G-X8K1JRJY27"
};
firebase.initializeApp(firebaseConfig);

const router = new VueRouter({
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes,
});

Vue.use(VueAnalytics, {
  id: 'G-KS302EEZQN', //'UA-75159326-1',
  router
});

router.beforeEach((to, from, next) => {
  let localBookingSession = localStorage.getItem('booking_session');
  // let localBookingSessionExpired = localStorage.getItem('booking_session_expired');
  let localBookingSessionStarted = localStorage.getItem('booking_session_started');
  const date1 = new Date()
  const date2 = new Date(localBookingSessionStarted)
  const FIVE_MIN = 5 * 60 * 1000
  if (localBookingSession !== 'undefined' && localBookingSession && date1 - date2 > FIVE_MIN) {
  // if (localBookingSession && new Date(localBookingSessionExpired).getTime() < new Date().getTime()) {
    http.post('/api/orders/cancel', {
      booking_session: JSON.parse(localBookingSession),
    }).then((response) => {
      window.console.log(response);
      localStorage.removeItem('booking_session');
      localStorage.removeItem('booking_session_expired');
      localStorage.removeItem('booking_session_started');
      localStorage.removeItem('current_event');
    }).catch(error => {
      console.error(error.response);
    });
  }
  if (localBookingSession === null) {
    localStorage.removeItem('booking_session');
    localStorage.removeItem('booking_session_expired');
    localStorage.removeItem('booking_session_started');
    localStorage.removeItem('current_event');
  }
  next();
});

(async () => {
  new Vue({
    router,
    i18n: await i18n(),
  }).$mount('#app');
})();
